"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailItemCaption = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _collapseContext = require("../../contexts/collapseContext");
var _hooks = require("../../hooks");
var _utils = require("../../utils");
var _constants = require("./constants");
var _hooks2 = require("./hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DetailItemCaption = ({
  caption
}) => {
  const {
    open,
    onToggle
  } = (0, _collapseContext.useCollapseContext)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const ref = (0, _react.useRef)(null);
  const showExpandButton = (0, _hooks2.useShowExpandButton)({
    caption,
    ref
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.DETAIL_ITEM_CAPTION),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Collapse, {
      in: open,
      collapsedSize: _constants.MIN_OVERFLOW_HEIGHT,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CaptionText, {
        ref: ref,
        align: "left",
        children: (0, _utils.prepareDescription)(caption)
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ButtonContainer, {
      children: showExpandButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ExpandButton, {
        isCaptionExpanded: open,
        size: "medium",
        "aria-expanded": open,
        "aria-label": translations.viewAll,
        variant: "text",
        color: "default",
        onClick: onToggle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {})
      }) : null
    })]
  });
};
exports.DetailItemCaption = DetailItemCaption;
